import { DATA_CATEGORY, DATA_SUBCATEGORY } from './getBodyAttributes';

export const getPageViewSpecialCategories = () => {
  const slug = document.body.getAttribute('data-slug');
  const model = document.body.getAttribute('data-model') || '';
  if (slug === 'home') return ['Homepage'];
  if (model === 'WhyPayfitPageRecord') {
    return ['why_payfit'];
  }

  if (model === 'ThankYouPageRecord') {
    return ['ThankYouPage'];
  }

  if (
    [
      'BlogArticleRecord',
      'BlogHomeRecord',
      'CategoryPageRecord',
      'SubCategoryPageRecord',
    ].includes(model)
  ) {
    const categories = ['Blog'];
    const category = document.body.getAttribute(DATA_CATEGORY);
    const subcategory = document.body.getAttribute(DATA_SUBCATEGORY);
    if (category) {
      categories.push(category);
    }
    if (subcategory) {
      categories.push(subcategory);
    }
    return categories;
  }

  return;
};
